import clsx from 'clsx';

const Price = ({
    amount,
    compareToPrice,
    className,
    currencyCode = 'USD',
    currencyCodeClassName,
}: {
    amount: number;
    compareToPrice?: number;
    className?: string;
    currencyCode: string;
    currencyCodeClassName?: string;
} & React.ComponentProps<'p'>) => (
    <div className="flex items-center space-x-2">
        {compareToPrice && compareToPrice > amount && (
            <p className="text-gray-700 line-through decoration-red-700 decoration text-base">
                {new Intl.NumberFormat(undefined, {
                    style: 'currency',
                    currency: currencyCode,
                    currencyDisplay: 'narrowSymbol',
                }).format(compareToPrice)}
            </p>
        )}
        <p className={className} suppressHydrationWarning={true}>
            {`${new Intl.NumberFormat(undefined, {
                style: 'currency',
                currency: currencyCode,
                currencyDisplay: 'narrowSymbol',
            }).format(amount)}`}
            <span className={clsx('ml-1 inline', currencyCodeClassName)}>
                {currencyCode}
            </span>
        </p>
    </div>
);

export default Price;
